var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LayoutPage',{staticClass:"news-page frettir-page"},[(!!_vm.posts)?_c('PostsFilter',{attrs:{"filters":_vm.filters,"posts":_vm.posts},on:{"getLimitPosts":function($event){return _vm.init()},"getSubFilter":_vm.subFilter}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }